export const locale = {
    lang: 'fr',
    data: {
        view: {
            resultsText: 'fr RESULTS',
            rowsText: 'fr Total Rows:',
            rowText: 'fr ROW',
            afterImportProcessResults: 'fr AFTER IMPORT PROCESS RESULTS'
        }
    }
};
